import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SpinnerService {
	private isLoadingSubject = new BehaviorSubject<boolean>(false);
	isLoading = this.isLoadingSubject.asObservable();

	show() {
		this.isLoadingSubject.next(true);
	}

	hide() {
		this.isLoadingSubject.next(false);
	}
}
